<template>
    <div class="information_component-container rodo-information">
        <h1>RODO</h1>
        <div v-html="translate(rodoCode)"></div>
        <div class="navi-btns">
            <div @click="$router.go(-1)" class="back-btn"><span>{{translate("back_btn")}}</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RODO",
        data () {
          return {
              rodoCode: "rodo_content"
          }
        },

        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        }
    }
</script>

<style scoped>

</style>